import { ListableString } from "./data";

export interface Staff extends ListableString {
  identifier: string;
  signin_code: string;
}

export const StaffFields: string[] = ["identifier"];
